import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  ServicesGrid,
  ServiceCard,
  ServiceIconWrapper,
  ServiceCardTitle,
  ServiceCardDescription,
} from '../styles';
import {
  CodeIcon,
  ArchitectureIcon,
  MigrationIcon,
  DatabaseIcon,
  SecurityIcon,
  CodeReviewIcon,
} from '../icons';

interface ServiceGridProps {
  themeName: ThemeType;
}

const icons = [
  <CodeIcon key={0} />,
  <ArchitectureIcon key={1} />,
  <MigrationIcon key={2} />,
  <DatabaseIcon key={3} />,
  <SecurityIcon key={4} />,
  <CodeReviewIcon key={5} />,
];

const ServiceGrid: React.FC<ServiceGridProps> = ({ themeName }) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper id="services" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ ls -la ./services/</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('services.title')}</SectionTitle>

      <ServicesGrid>
        {[1, 2, 3, 4, 5, 6].map((num, index) => (
          <ServiceCard key={num} $themeName={themeName}>
            <ServiceIconWrapper $themeName={themeName}>
              {icons[index]}
            </ServiceIconWrapper>
            <div>
              <ServiceCardTitle $themeName={themeName}>
                {t(`services.service${num}.title`)}
              </ServiceCardTitle>
              <ServiceCardDescription $themeName={themeName}>
                {t(`services.service${num}.description`)}
              </ServiceCardDescription>
            </div>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </SectionWrapper>
  );
};

export default ServiceGrid;
